

<div class="loader">
    <div class="loadersvg">
<svg width="200" height="200" viewBox="0 0 200 200"
     xmlns="http://www.w3.org/2000/svg">

  <!-- Center Logo (zoom in/out) -->
  <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 180 180"
       class="logo-pulse" x="65" y="70" width="70" height="60">
    <defs>
      <style>
        .cls-1 { fill: #005499; }
        .cls-2 { fill: transparent; }
        .cls-3 { fill: url(#linear-gradient); }
        .cls-4 { fill: #f46933; }
      </style>

      <linearGradient id="linear-gradient" x1="67.5" y1="138.43"
                      x2="94.88" y2="98.31" gradientUnits="userSpaceOnUse">
        <stop offset=".16" stop-color="#005499"/>
        <stop offset=".25" stop-color="#245789"/>
        <stop offset=".48" stop-color="#7c5e65"/>
        <stop offset=".67" stop-color="#bc644a"/>
        <stop offset=".81" stop-color="#e46739"/>
        <stop offset=".88" stop-color="#f46933"/>
      </linearGradient>
    </defs>

    <rect class="cls-2" width="180" height="180"/>
    <g>
      <g>
        <path class="cls-4"
              d="m118.15,72.15c-11.74,0-21.29-9.55-21.29-21.29s9.55-21.29,21.29-21.29,21.29,9.55,21.29,21.29-9.55,21.29-21.29,21.29Zm0-31.77c-5.78,0-10.48,4.7-10.48,10.48s4.7,10.48,10.48,10.48,10.48-4.7,10.48-10.48-4.7-10.48-10.48-10.48Z"/>
        <path class="cls-1"
              d="m57.28,74.74c-10.48,0-19.01-8.53-19.01-19.01s8.53-19.01,19.01-19.01,19.01,8.53,19.01,19.01-8.53,19.01-19.01,19.01Zm0-27.26c-4.55,0-8.25,3.7-8.25,8.25s3.7,8.25,8.25,8.25,8.25-3.7,8.25-8.25-3.7-8.25-8.25-8.25Z"/>
      </g>
      <g>
        <path class="cls-4"
              d="m118.31,78.7c-1.94-.07-14.32-.06-24.55,9.48l7.58,10.3c7.05-7.43,16.07-7.19,16.48-7.17,12.93-.17,23.6,10.29,23.59,23.24-.86,24.11-31.2,34.33-51.26,6.85-1.98,3.5-4.44,8.32-7.09,11.42,13.83,16.27,29.53,17.6,34.27,17.6,48.07-1.03,48.99-69.48.98-71.73Z"/>
        <path class="cls-1"
              d="m57.45,130.32c-24.6-.71-24.86-35.74-.28-36.8,7.44-.17,16.31,5.16,21.87,12.48,1.26-2.15,5.39-9.58,6.62-11.57-25.02-26.07-58.6-11.37-59.5,17.48-.07,23.72,26.94,40.3,48.26,25.53l-7.42-10.09c-5.08,3.1-8.22,2.91-9.54,2.96Z"/>
        <path class="cls-3"
              d="m87.3,96.22s0,0,0,0c-.52.87-13.57,23.86-13.57,23.86-1.94,3.47-4.36,5.77-6.73,7.29l7.42,10.09c2.47-1.71,4.87-3.84,7.13-6.43h0c2.44-2.58,13.56-23.28,15.67-26.7,1.22-2.34,2.63-4.26,4.12-5.84l-7.58-10.3c-2.31,2.16-4.51,4.79-6.46,8.03Z"/>
      </g>
    </g>
  </svg>

  <!-- Rotating arcs -->
  <circle cx="100" cy="100" r="50" fill="none"
          stroke="url(#grad1)" stroke-width="6"
          stroke-dasharray="140 500" stroke-linecap="round"
          class="rotate-slow"></circle>

  <circle cx="100" cy="100" r="50" fill="none"
          stroke="url(#grad2)" stroke-width="6"
          stroke-dasharray="140 500" stroke-linecap="round"
          class="rotate-fast"></circle>

  <defs>
    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#3b82f6"/>
      <stop offset="100%" stop-color="#6f09f7"/>
    </linearGradient>
    <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#3b82f6"/>
      <stop offset="100%" stop-color="#6f09f7"/>
    </linearGradient>
  </defs>

  <style>
    .logo-pulse {
      transform-origin: 100px 100px;
      animation: pulse 2s ease-in-out infinite;
    }

    .rotate-slow {
      transform-origin: 100px 100px;
      animation: spin 2s linear infinite;
    }

    .rotate-fast {
      transform-origin: 100px 100px;
      animation: spin 0.5s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes pulse {
      0%, 100% { transform: scale(0.5); }
      50% { transform: scale(0.8); }
    }
  </style>
</svg>
</div>
<div class="loaderoverflow">  </div>
</div>


